import React, { useState } from 'react'
import { IconButton, Menu, MenuItem, Stack, Tooltip, Typography, CircularProgress } from '@mui/material'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { useSnackbar } from 'notistack'
import { downloadPincodesForRow } from '../downloadPincodes'
import { intelColors } from './intelTheme'

// Per-row "download the real pincodes" action, reused across every serviceability_intel
// breakdown table. `options` mirrors the Bulk Serviceability Account Codes tab's download
// menu (one entry per pincode type relevant to THIS row/table) — when there's only one
// relevant type the menu is skipped and the button downloads directly.
export default function DownloadPincodesButton({ accountCodes, options, filterPincode, filenameBase }) {
  const { enqueueSnackbar } = useSnackbar()
  const [anchorEl, setAnchorEl] = useState(null)
  const [loadingKey, setLoadingKey] = useState(null)
  const codes = (accountCodes || []).filter(Boolean)
  const disabled = codes.length === 0

  const runDownload = async (opt) => {
    setAnchorEl(null)
    setLoadingKey(opt.key)
    const ok = await downloadPincodesForRow({
      accountCodes: codes,
      pincodeTypes: opt.pincodeTypes,
      filterPincode,
      filename: `${filenameBase}_${opt.key}${filterPincode ? `_${filterPincode}` : ''}.csv`,
    })
    setLoadingKey(null)
    if (!ok) {
      enqueueSnackbar(
        filterPincode ? `Pincode ${filterPincode} not found for this row` : 'No pincodes found for this row',
        { variant: 'warning' }
      )
    }
  }

  const handleClick = (e) => {
    if (disabled) return
    if (options.length === 1) { runDownload(options[0]); return }
    setAnchorEl(e.currentTarget)
  }

  return (
    <>
      <Tooltip title={disabled ? 'No account codes to download' : 'Download pincodes'} arrow>
        <span>
          <IconButton size='small' disabled={disabled || !!loadingKey} onClick={handleClick} sx={{ color: intelColors.primary }}>
            {loadingKey ? <CircularProgress size={14} /> : <FileDownloadOutlinedIcon sx={{ fontSize: 16 }} />}
          </IconButton>
        </span>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={() => setAnchorEl(null)}>
        {options.map((opt) => (
          <MenuItem key={opt.key} onClick={() => runDownload(opt)} disabled={!opt.count}>
            <Stack direction='row' justifyContent='space-between' sx={{ width: '100%' }} spacing={2}>
              <Typography sx={{ fontSize: 12.5 }}>{opt.label}</Typography>
              <Typography sx={{ fontSize: 11, color: 'grey.600' }}>{(opt.count || 0).toLocaleString()}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
